import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import ReportDefinitions from '../../../../../../common/config/ReportDefinitions';
import PredesPlannedTransportAnomaliesDestinationReport
  from '../../components/PredesPlannedTransportAnomaliesDestinationReport';
import {
  getColumns,
  getData,
  getGeneratedOnDateTime,
  getIsLoading,
} from '../redux/selectors/PredesPlannedTransportAnomaliesDestinationDetailsSelectors';

export function PredesPlannedTransportAnomaliesDestinationDetailsContainer(props) {
  return (
    <PredesPlannedTransportAnomaliesDestinationReport
      reportId={ReportDefinitions.PREDES_PLANNED_TRANSPORT_ANOMALIES_DESTINATION_DETAILS.id}
      columns={props.columns}
      isLoading={props.isLoading}
      generatedOnDateTime={props.generatedDateTime}
      data={props.data}
    />
  );
}

function mapStateToProps(state) {
  return {
    data: getData(state),
    generatedDateTime: getGeneratedOnDateTime(state),
    isLoading: getIsLoading(state),
    columns: getColumns(state),
  };
}

PredesPlannedTransportAnomaliesDestinationDetailsContainer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  generatedDateTime: PropTypes.string,
  isLoading: PropTypes.bool,
  columns: PropTypes.arrayOf(PropTypes.object),
};

export default connect(mapStateToProps)(PredesPlannedTransportAnomaliesDestinationDetailsContainer);
